import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Layouts
import DashboardLayout from '../components/layout/DashboardLayout';
import PublicLayout    from '../components/layout/PublicLayout';

// Auth
import LoginPage         from '../pages/auth/LoginPage';
import RegisterPage      from '../pages/auth/RegisterPage';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';

// Dashboard
import DashboardPage from '../pages/dashboard/DashboardPage';

// Assessments
import AssessmentListPage   from '../pages/assessments/AssessmentListPage';
import CreateAssessmentPage from '../pages/assessments/CreateAssessmentPage';
import EditAssessmentPage   from '../pages/assessments/EditAssessmentPage';
import AssessmentDetailPage from '../pages/assessments/AssessmentDetailPage';

// Questions
import QuestionLibraryPage from '../pages/questions/QuestionLibraryPage';
import AIGeneratorPage     from '../pages/questions/AIGeneratorPage';

// Participants
import ParticipantListPage   from '../pages/participants/ParticipantListPage';
import ParticipantDetailPage from '../pages/participants/ParticipantDetailPage';

// Bootcamps
import BootcampListPage   from '../pages/bootcamps/BootcampListPage';
import CreateBootcampPage from '../pages/bootcamps/CreateBootcampPage';
import EditBootcampPage   from '../pages/bootcamps/EditBootcampPage';

// Reports
import ReportsPage           from '../pages/reports/ReportsPage';

// Public
import AssessmentPage from '../pages/public/AssessmentPage';
import ThankYouPage   from '../pages/public/ThankYouPage';

// Settings
import SettingsPage from '../pages/settings/SettingsPage';

// Landing
import LandingPage                from '../pages/landing/LandingPage';
import PublicBootcampDetailPage   from '../pages/landing/PublicBootcampDetailPage';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"/></div>;
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* Landing */}
      <Route path="/"                    element={<LandingPage />} />
      <Route path="/bootcamp/:id"        element={<PublicBootcampDetailPage />} />

      {/* Auth */}
      <Route path="/login"           element={<PublicLayout><LoginPage /></PublicLayout>} />
      <Route path="/register"        element={<PublicLayout><RegisterPage /></PublicLayout>} />
      <Route path="/forgot-password" element={<PublicLayout><ForgotPasswordPage /></PublicLayout>} />

      {/* Public assessment */}
      <Route path="/a/:token"         element={<AssessmentPage />} />
      <Route path="/a/:token/thankyou"element={<ThankYouPage />} />

      {/* Protected app */}
      <Route path="/" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route path="dashboard"                element={<DashboardPage />} />
        <Route path="assessments"              element={<AssessmentListPage />} />
        <Route path="assessments/new"          element={<CreateAssessmentPage />} />
        <Route path="assessments/:id"          element={<AssessmentDetailPage />} />
        <Route path="assessments/:id/edit"     element={<EditAssessmentPage />} />
        <Route path="assessments/:id/participants" element={<ParticipantListPage />} />
        <Route path="participants/:id"         element={<ParticipantDetailPage />} />
        <Route path="bootcamps"                element={<BootcampListPage />} />
        <Route path="bootcamps/new"            element={<CreateBootcampPage />} />
        <Route path="bootcamps/:id/edit"       element={<EditBootcampPage />} />
        <Route path="questions"                element={<QuestionLibraryPage />} />
        <Route path="questions/ai"             element={<AIGeneratorPage />} />
        <Route path="reports"                  element={<ReportsPage />} />
        <Route path="settings"                 element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
